import { render } from "./signupStudent.vue?vue&type=template&id=3865dd0a&scoped=true"
import script from "./signupStudent.vue?vue&type=script&lang=js"
export * from "./signupStudent.vue?vue&type=script&lang=js"

import "./signupStudent.vue?vue&type=style&index=0&id=3865dd0a&scoped=true&lang=css"

import exportComponent from "E:\\工作\\校闪招\\code\\admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3865dd0a"]])

export default __exports__